import styles from "./CompanySmsSendingRuleRowEditV2.module.scss"

import {
	formatManuallyClaimingConversion,
	manuallyClaimingUnitKinds,
	selectableConversionDaysByManuallyClaimingUnitKind,
} from "@/souhl_admin/components/features/companies/sms-sending-rule/companySmsSendingRuleV2/CompanySmsSendingRuleV2.const"
import type { ManuallyClaimingUnitKind } from "@/souhl_admin/gql/__generated__/graphql"

// 「何に転換するか × 転換日数」は常にセットなので、select では 1 つの選択肢 (kind:days) として扱う。"" = 転換しない (通常の手動請求)
export type ManuallyClaimingConversion = {
	manuallyClaimingUnitKind: ManuallyClaimingUnitKind | null
	conversionDays: number | null
}

const NO_CONVERSION: ManuallyClaimingConversion = {
	manuallyClaimingUnitKind: null,
	conversionDays: null,
}

const NO_CONVERSION_OPTION_VALUE = ""

export const toConversionOptionValue = (
	conversion: ManuallyClaimingConversion
): string => {
	if (conversion.manuallyClaimingUnitKind === null) {
		return NO_CONVERSION_OPTION_VALUE
	}
	return `${conversion.manuallyClaimingUnitKind}:${
		conversion.conversionDays ?? ""
	}`
}

const conversionOptions: {
	value: string
	label: string
	conversion: ManuallyClaimingConversion
}[] = manuallyClaimingUnitKinds.flatMap((kind) =>
	selectableConversionDaysByManuallyClaimingUnitKind[kind].map((days) => {
		const conversion: ManuallyClaimingConversion = {
			manuallyClaimingUnitKind: kind,
			conversionDays: days,
		}
		return {
			value: toConversionOptionValue(conversion),
			label: formatManuallyClaimingConversion(conversion),
			conversion,
		}
	})
)

const conversionByOptionValue = new Map(
	conversionOptions.map((option) => [option.value, option.conversion])
)

// 選択肢に無い値 (= 転換しない "" を含む) は NO_CONVERSION に落とす
const parseConversionOptionValue = (
	value: string
): ManuallyClaimingConversion =>
	conversionByOptionValue.get(value) ?? NO_CONVERSION

export const ConversionSelect = ({
	value,
	onChange,
}: {
	value: string
	onChange: (conversion: ManuallyClaimingConversion) => void
}) => (
	<select
		className={styles.select}
		value={value}
		onChange={(e) => onChange(parseConversionOptionValue(e.target.value))}
	>
		<option value={NO_CONVERSION_OPTION_VALUE}>
			{formatManuallyClaimingConversion(NO_CONVERSION)}
		</option>
		{conversionOptions.map((option) => (
			<option key={option.value} value={option.value}>
				{option.label}
			</option>
		))}
	</select>
)
